export default __webpack_public_path__ + "static/FinanceBanner-472942b19d43ff082cd0e278fb83a9f4.jpg";